import { Reveal, SectionHeading } from "@/components/Reveal";
import { WHY_US } from "@/lib/site";

export default function WhyUs() {
  return (
    <section id="why" className="relative py-28 lg:py-36 bg-royal-800/60 spotlight-top" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="The Manifesto"
          title={<>WHY <span className="gold-text">HA TREASURE HOUSE?</span></>}
          testId="why-heading"
        />
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-14" data-testid="why-chapters">
          {WHY_US.map((w, i) => (
            <Reveal key={w.title} delay={0.08 * (i % 2)}>
              <div className="flex gap-6 items-start group" data-testid={`why-chapter-${i}`}>
                <span className="font-display text-5xl lg:text-6xl font-bold gold-text opacity-70 group-hover:opacity-100 transition-opacity duration-500 leading-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="border-l border-gold/25 pl-6">
                  <h3 className="font-display text-2xl text-cream">{w.title}</h3>
                  <p className="mt-2 text-muted leading-relaxed text-sm">{w.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
